/**
 * Quem administra a conta do cliente (portal.client_users.role).
 *
 * NÃO confundir com `AccessLevel`: papel responde quem administra o time no
 * painel, e nível responde o que a pessoa faz no projeto. Até 06/09/2026 os
 * dois compartilhavam o valor `tester` e o ERP mantinha um mapa traduzindo um
 * no outro, o que é o sintoma clássico de duas perguntas no mesmo campo.
 */
export const CLIENT_USER_ROLES = ['owner', 'membro'] as const
export type ClientUserRole = (typeof CLIENT_USER_ROLES)[number]

export const ROLE_LABELS: Record<ClientUserRole, string> = {
  owner: 'Dono da conta',
  membro: 'Membro',
}

/** O que o papel dá, em uma frase. */
export const ROLE_FAZ: Record<ClientUserRole, string> = {
  owner: 'administra o time e convida',
  membro: 'não administra o time',
}

// Roles em projeto (operacoes.project_members)
export const PROJECT_MEMBER_ROLES = ['dev', 'tech_lead', 'pm', 'gestao', 'designer'] as const
export type ProjectMemberRole = (typeof PROJECT_MEMBER_ROLES)[number]
